import React from 'react';

export default class APIErrorAlert extends React.Component {
    render() {
        var isHtmlError = this.props.error.includes('<!DOCTYPE html');
        if(isHtmlError) {
            return (
                <div
                    className="alert alert-danger"
                    dangerouslySetInnerHTML={{__html: this.props.error}}>
                </div>
            );
        }

        return (
            <div className="alert alert-danger">
                {this.props.error}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/APIErrorAlert.js